exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".store-logo[data-v-759021ec]{min-width:80px!important}.store-img[data-v-759021ec]{max-width:80px}.fav-store-name-wrap[data-v-759021ec]{position:relative}.fav-store-name-wrap p[data-v-759021ec]{width:calc(100% - 80px)}.fav-store-name-wrap .distance[data-v-759021ec]{position:absolute;top:1px;right:0}", ""]);

// exports
